export const LOGIN_MSISDN_START = 'LOGIN_MSISDN_START';
export const LOGIN_MSISDN_SUCCESS = 'LOGIN_MSISDN_SUCCESS';
export const LOGIN_MSISDN_FAIL = 'LOGIN_MSISDN_FAIL';
export const LOGIN_MSISDN_RESET = 'LOGIN_MSISDN_RESET';
